// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    
    const { t } = useTranslation();

    return(
        <section id="valutazione" className="space-ptb bg-overlay-white-10">
            <div className="container-fluid w-90">
                <div className="row">
                    <div className="col-12 col-lg-6 col-xl-5">
                            <p className="mb-0 sub-title">{t('homePage.sellBanner.subTitle')}</p>
                            <h2 className="mb-3">{t('homePage.sellBanner.title')}</h2>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }}></p>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para2') as string }}></p>
                            <Link to={'/valutazione'} title={t('homePage.sellBanner.linkTitle') as string} className="btn-primary ml-auto">
                                <span> {t('homePage.sellBanner.btnText')}</span>
                            </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;